import { render, staticRenderFns } from "./PaginasRevista.vue?vue&type=template&id=5078512b&scoped=true"
import script from "./PaginasRevista.vue?vue&type=script&lang=ts"
export * from "./PaginasRevista.vue?vue&type=script&lang=ts"
import style0 from "./PaginasRevista.vue?vue&type=style&index=0&id=5078512b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078512b",
  null
  
)

export default component.exports